import { createAsyncAction } from 'typesafe-actions';
import * as types from './notification.actionTypes';
import { INotificationStore } from './notification.type';
export const fetchLmsNotificationAsync = createAsyncAction(
	types.FETCH_LMS_NOTIFICATION_REQUEST,
	types.FETCH_LMS_NOTIFICATION_SUCCESS,
	types.FETCH_LMS_NOTIFICATION_FAILURE,
)<undefined, INotificationStore[], string>();
